import React from "react";
import { useMutation } from "@apollo/react-hooks";
import { useCurrentCustomerContext } from "components/current-customer-context";
import Dashboard from "components/dashboard";
import { PageHeaderBar, PageSection } from "components/page";
import UserForm from "./forms/common-form";
import { mutation, defaultValues, handleSubmit } from "./forms/new-form";

const UserNewPage = ({ history }) => {
  const { contracts } = useCurrentCustomerContext();

  const [createUser] = useMutation(mutation);
  const { currentCustomerId } = useCurrentCustomerContext();

  return (
    <Dashboard>
      <PageHeaderBar title="app.page.user.new" />
      <PageSection>
        <UserForm
          initialValues={defaultValues}
          contracts={contracts}
          isNewForm
          onSubmit={handleSubmit({
            createUser,
            history,
            customerId: currentCustomerId,
            contracts,
          })}
        />
      </PageSection>
    </Dashboard>
  );
};

export default UserNewPage;
